








































import type { CanalVendaMarketplace, Page, Pageable } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindCanalDeVendaMarketplaceUseCase } from '@/usecases/marketplace/FindCanalDeVendaMarketplaceUseCase'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'

@Component({
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeCanalDeVendaMarketplace extends Vue {
	canaisJaCadastrados: CanalVendaMarketplace[] = []
	canaisVenda: CanalVendaMarketplace[] = []
	busca = ''
	buscandoNovosItens = false
	cancelToken: CancelTokenSource | null = null
	pagina: Page<CanalVendaMarketplace> | null = null
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	
	findCanalDeVendaMarketplaceUseCase =  new FindCanalDeVendaMarketplaceUseCase()

	get canaisVendaFormatados() {

		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens) {
			return [
				...this.canaisVenda.filter(canal => !this.canaisJaCadastrados.map(canalJaCadastrado => canalJaCadastrado.codigo).includes(canal.codigo)),
				...[{ tipo: 'buscar-mais' }],
			]
		}
		return this.canaisVenda.filter(canal => !this.canaisJaCadastrados.map(canalJaCadastrado => canalJaCadastrado.codigo).includes(canal.codigo))
	}

	@Watch('busca')
	async onChangeBusca() {
		this.paginacao.page = 0

		this.canaisVenda = await this.buscar({
			...this.paginacao,
		})
	}

	async created() {
		this.canaisVenda = await this.buscar({
			...this.paginacao,
			page: 0,
		})
	}

	async buscarNovosItens() {
		this.buscandoNovosItens = true
		const canaisVendaNovos = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})

		this.canaisVenda = [
			...this.canaisVenda,
			...canaisVendaNovos,
		]

		this.buscandoNovosItens = false
	}

	async buscar(paginavel: Pageable) {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.pagina = await this.findCanalDeVendaMarketplaceUseCase.findAll({
				busca: this.busca || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
			}, axiosConfig)
			
			this.paginacao.page = this.pagina?.number || 0

			return this.pagina?.content || []
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoNovosItens) this.buscarNovosItens()
	}

	filtrar(item: any, queryText, itemText) {
		if (item.tipo === 'header') return false

		const hasValue = val => (val ? val : '')
		const textLower = hasValue(itemText).toString().toLowerCase()
		const queryLower = hasValue(queryText).toString().toLowerCase()

		if (item.tipo === 'buscar-mais') return this.pagina && !this.pagina.last

		return textLower.includes(queryLower)
	}
}
